module.exports = __webpack_public_path__ + "static/img/vi.4952d5bf.svg";